export var LibraryDtoLibrarySystemEnum;
(function (LibraryDtoLibrarySystemEnum) {
    LibraryDtoLibrarySystemEnum["TRITIUS"] = "TRITIUS";
    LibraryDtoLibrarySystemEnum["ALEPH"] = "ALEPH";
    LibraryDtoLibrarySystemEnum["ARL"] = "ARL";
    LibraryDtoLibrarySystemEnum["KONIAS"] = "KONIAS";
    LibraryDtoLibrarySystemEnum["VERBIS"] = "VERBIS";
    LibraryDtoLibrarySystemEnum["UNDEFINED"] = "UNDEFINED";
})(LibraryDtoLibrarySystemEnum || (LibraryDtoLibrarySystemEnum = {}));
export { LibraryDtoLibrarySystemEnum as LibrarySystemEnum };
